<script setup lang="ts">
  import { ref } from 'vue'
  import IconQC from '@qicgroupdoha/qic-connect-ds/components/IconQC'

  interface Props {
    disabled?: boolean
    show?: boolean
    arrowPosition?: 'left' | 'right'
    dataTestId?: string
  }
  interface Emits {
    (e: 'accordionClick'): void
  }

  const props = withDefaults(defineProps<Props>(), {
    disabled: false,
    show: false,
    arrowPosition: 'left',
    dataTestId: undefined,
  })
  const emit = defineEmits<Emits>()

  const expanded = ref<boolean>(props.show)

  const toggleExpanded = () => {
    if (props.disabled) return

    expanded.value = !expanded.value
    emit('accordionClick')
  }
</script>

<template>
  <div class="accordion-item">
    <div
      class="accordion-header"
      :aria-expanded="expanded"
      :data-test="dataTestId"
      @click="toggleExpanded"
    >
      <div class="accordion-header__wrapper">
        <span
          v-if="props.arrowPosition === 'left'"
          class="icon"
          :class="{ 'disable-arrow': disabled }"
          :aria-hidden="!expanded"
        >
          <!-- @vue-ignore -->
          <IconQC name="chevron-down" :color="$qicConnect.colors.icn.srf.tertiary" size="lg" />
        </span>
        <span class="accordion-title paragraph-default-bold">
          <slot name="name"></slot>
        </span>
        <span class="accordion-desc">
          <slot name="desc"></slot>
        </span>
        <span
          v-if="props.arrowPosition === 'right'"
          class="icon icon--right"
          :class="{ 'disable-arrow': disabled }"
          :aria-hidden="!expanded"
        >
          <!-- @vue-ignore -->
          <IconQC name="chevron-down" :color="$qicConnect.colors.icn.srf.tertiary" size="lg" />
        </span>
      </div>
      <slot name="bottom-desc"></slot>
    </div>
    <div v-show="expanded" class="accordion-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .accordion-header {
    cursor: pointer;
    .icon {
      transition: 0.1s;
      line-height: 0;
    }

    .icon--right {
      margin-inline-start: auto;
    }

    &[aria-expanded='true'] {
      .icon {
        transform: rotate(180deg);
      }
    }
  }

  .accordion-title {
    word-break: break-word;
  }
</style>
